module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-4"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "id": "imageUpload",
      "type": "file"
    },
    on: {
      "change": _vm.onFileSelect
    }
  })]), _vm._v(" "), (this.url !== null) ? _c('div', {
    staticClass: "p-field p-col-4"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-content"
  }, [_c('div', {
    staticClass: "p-mb-3"
  }, [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    },
    attrs: {
      "src": this.url
    }
  })]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-3"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "Remove"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeImage.apply(null, arguments)
      }
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-4"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "id": "imageUpload1",
      "type": "file"
    },
    on: {
      "change": _vm.onCitizenshipSelect
    }
  })]), _vm._v(" "), (this.url1 !== null) ? _c('div', {
    staticClass: "p-field p-col-4"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-content"
  }, [_c('div', {
    staticClass: "p-mb-3"
  }, [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    },
    attrs: {
      "src": this.url1
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "p-field p-col-3"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Remove"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeCitizenship.apply(null, arguments)
      }
    }
  })], 1)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-4"
  }, [_vm._m(2), _vm._v(" "), _c('input', {
    staticStyle: {
      "margin-bottom": "2em"
    },
    attrs: {
      "id": "imageUpload3",
      "type": "file"
    },
    on: {
      "change": _vm.onCvSelect
    }
  })]), _vm._v(" "), (this.url2 !== null) ? _c('div', {
    staticClass: "p-field p-col-4"
  }, [_c('div', {
    staticClass: "product-item"
  }, [_c('div', {
    staticClass: "product-item-content"
  }, [_c('div', {
    staticClass: "p-mb-3"
  }, [_c('img', {
    staticClass: "product-image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    },
    attrs: {
      "src": this.url2
    }
  })]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "p-field p-col-3"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-danger",
    attrs: {
      "label": "Remove"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.removeCvFile.apply(null, arguments)
      }
    }
  })], 1)])])])]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "imageUpload"
    }
  }, [_c('i', {
    staticClass: "pi pi-cloud-upload"
  }, [_vm._v(" Personal")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "imageUpload1"
    }
  }, [_c('i', {
    staticClass: "pi pi-cloud-upload"
  }, [_vm._v(" Citizenship")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "imageUpload3"
    }
  }, [_c('i', {
    staticClass: "pi pi-cloud-upload"
  }, [_vm._v(" CV")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-591c5049"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/HumanResource/Employee/documentUpload.vue
// module id = 2245
// module chunks = 0